import _ from 'lodash';
import beginsWithQueryExpression from './queryExpressions/beginsWithQueryExpression.js';
import containsQueryExpression from './queryExpressions/containsQueryExpression.js';
import containsWordsQueryExpression from './queryExpressions/containsWordsQueryExpression.js';
import insensitiveEqualQueryExpression from './queryExpressions/insensitiveEqualQueryExpression.js';
import createDateRangeQueryExpression from './queryExpressions/dateRangeQueryExpression.js';
import createSimpleQueryExpression from './queryExpressions/simpleQueryExpression.js';
import createItemMatchQueryExpression from './queryExpressions/itemMatchQueryExpression.js';
import createDateTimeRangeQueryExpression from './queryExpressions/createDateTimeRangeQueryExpression.js';

export default function getQueryOperatorExpressions(getQueryExpression) {
  return {
    contains: containsQueryExpression,
    containsWords: containsWordsQueryExpression,
    beginsWith: beginsWithQueryExpression,
    equal: createSimpleQueryExpression('$eq'),
    insensitiveEqual: insensitiveEqualQueryExpression,
    notEqual: createSimpleQueryExpression('$ne'),
    in: createSimpleQueryExpression('$in'),
    notIn: createSimpleQueryExpression('$nin'),
    exists: createSimpleQueryExpression('$exists'),
    lessThan: createSimpleQueryExpression('$lt'),
    lessOrEqualThan: createSimpleQueryExpression('$lte'),
    greaterThan: createSimpleQueryExpression('$gt'),
    greaterOrEqualThan: createSimpleQueryExpression('$gte'),
    dateRangeExpression: createDateRangeQueryExpression(getQueryExpression),
    dateTimeRangeExpression: createDateTimeRangeQueryExpression(getQueryExpression),
    itemMatch: createItemMatchQueryExpression(getQueryExpression),
    $and: {
      getPathExpression: (path, value) => ({
        $and: _.map(value, c => getQueryExpression(c))
      })
    },
    $or: {
      getPathExpression: (path, value) => ({
        $or: _.map(value, c => getQueryExpression(c))
      })
    }
  };
}
